import React, { useEffect, useState } from "react";
import { IconNotVerified, IconVerified } from "../../components/icons";
import { Form, Input, Button } from "antd";
import {
  unverifyEmail,
  verificationRequestEmail,
  verifyEmail,
} from "../../api";
import { VERIFICATION } from "../../constants";
import EnterOtp from "../../components/common/EnterOtp";
import { useTranslation } from "react-i18next";
import { commonUtil } from "../../utils";
import { ValidationForm } from "../../common/interfaces";

interface Props {
  reload: Function;
  identifier: any;
  canUnlink: boolean;
}

const UpdateEmail: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(["common", "notification"]);
  const [verificationId, setVerificationId] = useState<number>(0);
  const [email, setEmail] = useState<string>("");
  const [showEnterOtp, setShowEnterOtp] = useState<boolean>(false);
  const [validateEmail, setValidateEmail] = useState<ValidationForm | null>(
    null
  );

  useEffect(() => {
    setEmail(props.identifier ? props.identifier.identifier_value : "");
  }, [props.identifier]);

  const onChange = (value: string) => {
    setEmail(value.trim());
    setValidateEmail(null);
  };

  const onClickGetOtp = async () => {
    if (!email || !email.trim()) {
      setValidateEmail({
        status: "error",
        text: t("notification:Vui lòng nhập email"),
      });
      return;
    }
    if (!commonUtil.isEmailValid(email)) {
      setValidateEmail({
        status: "error",
        text: t("notification:Email không đúng định dạng"),
      });
      return;
    }
    const res = await verificationRequestEmail({
      feature: VERIFICATION.FEATURE.PROFILE_VERIFIED,
      email,
    });
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
    } else {
      setVerificationId(res.data.verificationId);
      setShowEnterOtp(true);
    }
  };

  const renderActionButton = () => {
    if (!email) {
      return null;
    }
    if (!commonUtil.isEmailValid(email)) {
      return null;
    }
    if (
      props.identifier &&
      props.identifier.status === "verified" &&
      email === props.identifier.identifier_value
    ) {
      return null;
    }
    return (
      <>
        {t("common:Email này chưa được xác minh")}.&nbsp;
        <a onClick={onClickGetOtp} style={{ color: "#ef4343" }}>
          {t("common:Gửi mã xác thực")}
        </a>
      </>
    );
  };

  const onClickRemoveEmail = async () => {
    const res = await unverifyEmail();
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
      return;
    }
    props.reload();
  };

  const onConfirmOtpSuccess = async () => {
    const res = await verifyEmail({ verificationId, email });
    if (res.status === "error") {
      commonUtil.showMessage("error", res.message);
      return;
    }
    setShowEnterOtp(false);
    props.reload();
  };

  return (
    <>
      <Form.Item
        validateStatus={validateEmail?.status}
        help={validateEmail?.text}
        label={
          <div className="flex items-center gap-4">
            {t("common:Email")}&nbsp;
            {props.identifier && props.identifier.status === "verified" ? (
              <IconVerified />
            ) : (
              <IconNotVerified />
            )}
          </div>
        }
      >
        <Input
          disabled={props.identifier && props.identifier.status === "verified"}
          placeholder={"Email"}
          value={email}
          style={{ backgroundColor: "white", color: "black" }}
          onChange={(event) => onChange(event.target.value)}
          suffix={
            props.identifier &&
            props.identifier.status === "verified" &&
            props.canUnlink ? (
              <span
                style={{ color: "#F5222D", cursor: "pointer" }}
                onClick={(e) => onClickRemoveEmail()}
              >
                {t("common:Bỏ kết nối")}
              </span>
            ) : null
          }
        />
        {renderActionButton()}
      </Form.Item>
      {showEnterOtp ? (
        <EnterOtp
          verificationId={verificationId}
          type={"email"}
          feature={VERIFICATION.FEATURE.PROFILE_VERIFIED}
          value={email}
          onClose={() => {
            setShowEnterOtp(false);
          }}
          onResend={(verificationId) => {
            setVerificationId(verificationId);
          }}
          onConfirmSuccess={onConfirmOtpSuccess}
        />
      ) : null}
    </>
  );
};

export default UpdateEmail;
